import { isDefined } from 'ts-utils';
import { ApiClient } from '../api/ApiClient';
import { isCorrectFormatForReferralId } from '../config/AssessmentUtils';
import { ReferralState } from '../store/referral/ReferralState';
import { store } from '../store/Store';
import { recordError } from '../util/Errors';

export async function addUserToAvailableHcpReferral(userId: string): Promise<void> {
  const apiClient = new ApiClient();
  const { referralId, hasUserId } = store.getState().referral;

  if (isDefined(referralId) && hasUserId === false) {
    await apiClient.addUserToHcpReferral({ referralId, userId });
  }
}

export async function getReduxReferralState(referralId: string): Promise<ReferralState> {
  const NO_REFERRAL_FOUND_RESPONSE: ReferralState = {
    exists: false,
    hasUserId: false,
    hasAccessCode: false,
    isAslReferral: false,
    isWearableProvided: false,
    isPapReferral: false,
    referralId: undefined,
    loading: false,
    error: undefined,
  };
  if (!isCorrectFormatForReferralId(referralId)) {
    return NO_REFERRAL_FOUND_RESPONSE;
  }

  const apiClient = new ApiClient();

  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { success, ...basicInfo } = await apiClient.getBasicReferralInfo({ referralId });
    return { ...basicInfo, loading: false, error: undefined };
  } catch (error) {
    recordError(error);
    return {
      ...NO_REFERRAL_FOUND_RESPONSE,
      error:
        (error as Error).message ??
        'Failed to fetch referral information (apiClient.getBasicReferralInfo threw)',
    };
  }
}
